import { forwardRef, useEffect, useRef, useState } from 'react';
import { MuiTelInput, MuiTelInputProps } from 'mui-tel-input';
import { SxProps, Theme } from '@mui/material';
import './PhoneNumberField.scss';

type Props = Omit<MuiTelInputProps, 'inputRef' | 'sx' | 'size'> & {
    size?: 'medium' | 'small';
    sx?: SxProps<Theme>;
};

const PhoneNumberField = forwardRef<HTMLDivElement, Props>(function PhoneNumberField(
    { size = 'medium', sx, ...rest },
    ref
) {
    const phoneRef = useRef<HTMLInputElement | null>(null);
    const [labelOnTop, setLabelOnTop] = useState<boolean>(false);

    const paddingMedium = '20px';
    const paddingSmall = '8px 16px';

    const translateValue = size === 'medium' ? 'translate(87px, 20px)' : 'translate(87px, 6px)';

    useEffect(() => {
        const value: string | undefined = phoneRef?.current?.value || rest.value;
        setLabelOnTop(!!value);
    }, [phoneRef?.current?.value, rest.value]);

    const styles = {
        '& input': {
            padding: size === 'medium' ? paddingMedium : paddingSmall,
            lineHeight: '20px',
        },
        '& fieldset': { borderColor: '#e7e7e7' },
        // '& .MuiOutlinedInput-root:hover fieldset': {borderColor: 'red'},
        '& .MuiOutlinedInput-root:hover legend': { width: labelOnTop ? 'auto' : '0' },
        '& .MuiOutlinedInput-root legend': { width: labelOnTop ? 'auto' : '0' },
        '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#282828',
            borderWidth: '1px',
        },
        '& label': {
            fontFamily: 'Assistant, sans-serif',
            fontSize: '15px',
            top: '2px',
            left: '0px',
            color: labelOnTop ? '#282828' : '#686868',
            transform: labelOnTop ? 'translate(14px, -11px) scale(0.79)' : translateValue,
        },
        '& label.Mui-focused': {
            top: '2px',
            left: '0',
            color: '#282828',
            transform: 'translate(14px, -11px) scale(0.79)',
        },
        '& legend': { width: '0' },
        '& .MuiInputBase-root.Mui-focused legend': { width: 'auto' },

        '& .Mui-error .MuiOutlinedInput-notchedOutline ': { borderColor: '#ff2727' },
        '.Mui-error.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ff2727',
        },
        '& label .MuiFormLabel-root-MuiInputLabel-root.Mui-error': { color: 'green' },
        '& label.Mui-error': { color: '#282828' },
        '.MuiTelInput-Menu': { top: '300px', border: '5px solid red' },
        ...sx,
    };

    return (
        <MuiTelInput
            ref={ref}
            inputRef={phoneRef}
            sx={styles}
            InputLabelProps={{ shrink: true }}
            MenuProps={{ className: 'mui-tel-input-menu-field' }}
            {...rest}
        />
    );
});

export default PhoneNumberField;
